import { useState, useEffect, useContext } from "react";
import { useNavigate } from 'react-router-dom';
import "../../css/ListUsers.css";
import FetchUtil from "../../utils/FetchUtil";
import UserContext from "../../contexts/UserContext";
import { useTranslation } from 'react-i18next';
import DelegateProductReadOnlyRow from "../../components/DelegateProductReadOnlyRow";
import DelegateProductTableRow from "../../components/DelegateProductTableRow";


function ListDelegateProducts({ indirectBuyerKey, buyerKey, partnershipKey, selectedDelegate, level, setProduct }) {
    const navigate = useNavigate();
    const [add, setAdd] = useState(false);
    const [addRowTop, setAddRowTop] = useState(false);
    const [addRowBottom, setAddRowBottom] = useState(false);

    const [errorValue, setErrorValue] = useState("");
    const [delegateProducts, setDelegateProducts] = useState([]);
    const [editableRecord, setEditableRecord] = useState({});
    const [count, setCount] = useState(0);
    const { t } = useTranslation();
    const userCtx = useContext(UserContext);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        fetchDelegateProduct();
    }, []);

    const initialValues = {
        delegateProductKey: 0,
        productKey: 0,
        buyerKey: buyerKey,
        companyKey: 0,
        indirectBuyerKey: indirectBuyerKey,
        statusCode: 1,
        level: level,
        delegateKey: 0,
        partnershipKey: partnershipKey,
    };

    const [editFormData, setEditFormData] = useState(initialValues);

    const resetCounter = () => {
        setCount(prevCount => prevCount + 1);
    };
    function fetchDelegateProduct() {
        setErrorValue("");
        if ((!indirectBuyerKey || indirectBuyerKey === 0)) {
            setErrorValue(t("error.indirectBuyer.Reqd"));
            return;
        }
        if ((!buyerKey || buyerKey === 0)) {
            setErrorValue(t("error.buyer.Reqd"));
            return;
        }
        if ((!selectedDelegate.companyId || selectedDelegate.companyId == 0)) {
            setErrorValue(t("error.suplrReqd"));
            return;
        }
        setIsLoading(true);
        resetCounter();
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                source: "web", getAll: true,
                indirectBuyerKey: indirectBuyerKey,
                buyerKey: buyerKey,
                companyKey: selectedDelegate.companyId,
                level: level,
            }),
        };
        try {
            FetchUtil.fetchAPI("GetDelegateProducts", "/Service/CompanyService/GetDelegateProducts", requestOptions, fetchDelegateProductSuccess, fetchDelegateProductFail);
        } catch (error) {
            setIsLoading(false);
            throw new Error(error.message);
        }
    }

    function fetchDelegateProductFail(redirect) {
        setIsLoading(false);
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.delegateProductNotRetrieved"));
    }

    function fetchDelegateProductSuccess(responseData) {
        let getDelegateProductResponse;
        if (responseData) {
            getDelegateProductResponse = responseData.getDelegateProductResponse;
            if (getDelegateProductResponse && getDelegateProductResponse.errorCode === "0") {
                if (getDelegateProductResponse.products) {
                    setDelegateProducts([...getDelegateProductResponse.products]);
                } else {
                    setDelegateProducts([]);
                }
            } else if (getDelegateProductResponse && getDelegateProductResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else if (getDelegateProductResponse) {
                setErrorValue(t("error.error") + " " + getDelegateProductResponse.errorMessage);
            } else {
                setErrorValue(t("error.system.fetch"));
            }
        }
        setIsLoading(false);
    }

    const addRowTableTop = () => {
        setAddRowTop(true);
        setAddRowBottom(false);
        addRowTable();
    };

    const addRowTableBottom = () => {
        setAddRowTop(false);
        setAddRowBottom(true);
        addRowTable();
    };

    const addRowTable = () => {
        setErrorValue("");
        if (!add) {
            setAdd(true);
        } else {
            if (add) {
                setErrorValue(t("error.only1RowAllowed"));
            }
        }
    };
    const removeRowTable = () => {
        setErrorValue("");
        resetRowTable();
        setIsLoading(false);
    };

    const resetRowTable = () => {
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
    };
    const handleClose = () => {
        setErrorValue("");
        setAddRowTop(false);
        setAddRowBottom(false);
        setAdd(false);
        setProduct(false);
    }
    const handleDeleteClick = (event, delegateProductItem, completeCallback) => {
        event.preventDefault();
        setErrorValue("");
        deleteDelegateProduct(delegateProductItem, completeCallback);
    };

    const deleteDelegateProduct = (delegateProductItem, completeCallback) => {
        let action = 3;
        if (delegateProductItem.statusCode === 1) {
            action = 4;
        }
        let serverParams = {
            delegateProductKey: delegateProductItem.delegateProductKey,
            statusCode: delegateProductItem.statusCode,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };
        try {
            FetchUtil.fetchAPI("DeleteDelegateProduct", "/Service/CompanyService/DeleteDelegateProduct", requestOptions, deleteDelegateProductSuccess, deleteDelegateProductFail, completeCallback);
        } catch (error) {
            setErrorValue(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    }

    function deleteDelegateProductFail(redirect, completeCallback) {
        if (redirect) {
            navigate("/");
        }
        setErrorValue(t("error.delegateProductDeleteFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function deleteDelegateProductSuccess(responseData, completeCallback) {
        let deleteDelegateProductResponse;
        if (responseData) {
            deleteDelegateProductResponse = responseData.deleteDelegateProductResponse;
            if (deleteDelegateProductResponse && deleteDelegateProductResponse.errorCode === "0") {
                resetRowTable();
                fetchDelegateProduct();
            } else if (deleteDelegateProductResponse && deleteDelegateProductResponse.errorCode === "114") {
                navigate("/", {
                    state: {
                        errorMessage: t("error.sessionTimeout"),
                    },
                });
            } else {
                setErrorValue(t("error.error") + " " +
                    deleteDelegateProductResponse.errorMessage
                );
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }

    const handleSubmit = (action, setValues, completeCallback) => {
        setErrorValue("");
        let found = false;
        if (action === 2) {
            editFormData.delegateProductKey = setValues.delegateProductKey;
        } else {
            editFormData.delegateProductKey = 0;
        }

        editFormData.companyKey = setValues.companyKey;
        editFormData.productKey = setValues.productKey;
        editFormData.delegateKey = setValues.delegateKey;
        if (!editFormData.companyKey || editFormData.companyKey == 0) {
            setErrorValue(t("error.companyReqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (!buyerKey || buyerKey == 0) {
            setErrorValue(t("error.buyer.Reqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (!indirectBuyerKey || indirectBuyerKey == 0) {
            setErrorValue(t("error.indirect.buyer.Reqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (!editFormData.productKey || editFormData.productKey == 0) {
            setErrorValue(t("error.prod.Reqd"));
            if (completeCallback) {
                completeCallback();
            }
            return false;
        }
        if (action === 1) {
            if (delegateProducts.length > 0) {
                delegateProducts.map((delegateProduct, index) => {
                    if (delegateProduct.companyId === editFormData.companyKey
                        && delegateProduct.buyerKey === buyerKey
                        && delegateProduct.indirectBuyerKey === indirectBuyerKey
                        && delegateProduct.productKey === editFormData.productKey
                        && delegateProduct.delegateKey === editFormData.delegateKey) {
                        setErrorValue(t("error.delegateProductDup"));
                        found = true;
                        if (completeCallback) {
                            completeCallback();
                        }
                        return false;
                    }
                })
            }
            if (!found) {
                saveDelegateProduct(action, completeCallback);
            }
        }
    };
    const saveDelegateProduct = (action, completeCallback) => {
        let serverParams = {
            delegateProductKey: editFormData.delegateProductKey,
            companyId: editFormData.companyKey,
            buyerKey: buyerKey,
            indirectBuyerKey: indirectBuyerKey,
            companyProductKey: editFormData.productKey,
            delegateKey: editFormData.delegateKey,
            source: "web",
            action: action
        };
        const requestOptions = {
            credentials: "same-origin",
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(serverParams),
        };

        try {
            FetchUtil.fetchAPI("AddUpdateDelegateProduct", "/Service/CompanyService/AddUpdateDelegateProduct", requestOptions, saveDelegateProductSuccess, saveDelegateProductFail, completeCallback);
        } catch (error) {
            setErrorValue(error.message);
            if (completeCallback) {
                completeCallback();
            }
        }
    };

    function saveDelegateProductFail(redirect, completeCallback) {
        setErrorValue(t("error.delegateProductSaveFailed"));
        if (completeCallback) {
            completeCallback();
        }
    }
    function saveDelegateProductSuccess(responseData, completeCallback) {
        let addUpdateDelegateProductResponse;
        if (responseData) {
            addUpdateDelegateProductResponse = responseData.addUpdateDelegateProductResponse;
            if (addUpdateDelegateProductResponse) {
                if (addUpdateDelegateProductResponse.errorCode === "0") {
                    resetRowTable();
                    fetchDelegateProduct();
                } else if (addUpdateDelegateProductResponse.errorCode === "114") {
                    navigate("/", {
                        state: {
                            errorMessage: t("error.sessionTimeout"),
                        },
                    });
                } else {
                    setErrorValue(t("error.error") + " " +
                        addUpdateDelegateProductResponse.errorMessage
                    );
                }
            }
        }
        if (completeCallback) {
            completeCallback();
        }
    }
    return (
        <>
            {(userCtx.role === "SiteAdmin") ?
                <div className="modalContainer-sm hide-scrollbar">
                    <div className="row">
                        <div className="col">
                            <h5 style={{ marginLeft: "2vw", textAlign: 'center' }}><b><span style={{ fontSize: "18px" }}></span>{t("header.admin.DelegateProduct")}</b></h5>
                        </div>
                    </div>
                    <div className="row" style={{ margin: "0px" }}>
                        <div className="col">
                            <a class="popup-close" id="boxclose" onClick={(e) => handleClose(e)} ></a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div
                                id="inerrorMessage"
                                className={
                                    (errorValue) ? "errorblock" : "errorblock hide"
                                }
                            >
                                {errorValue ? errorValue : ""}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_1" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <table className="list-table" role="table">
                                <thead>
                                    <tr role="row">
                                        <th className="list-th" style={{ maxWidth: "20vw" }}>{t("page.secondarySupplierName")}</th>
                                        <th className="list-th">{t("page.prodName")}</th>
                                        <th className="list-th">{t("page.prodNum")}</th>
                                        <th className="list-th">{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableTop}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody role="rowgroup">
                                    {add && addRowTop &&
                                        <DelegateProductTableRow
                                            index={count}
                                            selectedDelegate={selectedDelegate}
                                            primaryBuyerCompanyId={buyerKey}
                                            secondaryBuyerCompanyId={indirectBuyerKey}
                                            delegateProductItem={{}}
                                            handleSubmit={handleSubmit}
                                            setError={setErrorValue}
                                            t={t}
                                            setAdd={setAdd}
                                            oddIdx={((delegateProducts.length % 2) > 0) ? true : false} />
                                    }
                                    {delegateProducts.length > 0 && (
                                        delegateProducts.map((delegateItem, index) => (
                                            <DelegateProductReadOnlyRow
                                                index={count}
                                                t={t}
                                                delegateItem={delegateItem}
                                                handleDeleteClick={handleDeleteClick}
                                                oddIdx={((index % 2) > 0) ? true : false}
                                                setError={setErrorValue}
                                            />
                                        ))
                                    )}
                                    {add && addRowBottom &&
                                        <DelegateProductTableRow
                                            index={count}
                                            selectedDelegate={selectedDelegate}
                                            primaryBuyerCompanyId={buyerKey}
                                            secondaryBuyerCompanyId={indirectBuyerKey}
                                            delegateProductItem={{}}
                                            handleSubmit={handleSubmit}
                                            setError={setErrorValue}
                                            t={t}
                                            setAdd={setAdd}
                                            oddIdx={((delegateProducts.length % 2) > 0) ? true : false} />
                                    }
                                </tbody>
                                {(delegateProducts.length > 10) ? (<tfoot>
                                    <tr role="row">
                                        <th className="list-th">{t("page.secondarySupplierName")}</th>
                                        <th className="list-th">{t("page.prodName")}</th>
                                        <th className="list-th">{t("page.prodNum")}</th>
                                        <th className="list-th">{t("page.status")}</th>
                                        <th className="list-th" style={{ maxWidth: "9vw" }}>
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={addRowTableBottom}>
                                                {t("page.addRow")}
                                            </button>&nbsp;&nbsp;
                                            <button className="btn btn-primary btn-sm me-2 mb-1" onClick={removeRowTable}>
                                                {t("page.delRow")}
                                            </button>
                                        </th>
                                    </tr>
                                </tfoot>
                                ) : (<></>)}
                            </table>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div
                                id="berrorMessage"
                                className={
                                    (errorValue) ? "errorblock" : "errorblock hide"
                                }
                            >
                                {errorValue ? errorValue : ""}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <div id="placeholder_2" className="placeholder-pg"></div>
                        </div>
                    </div>
                    <div className="footer">
                        <input
                            type="button"
                            name="delegate-product-close"
                            id="delegate-product-close"
                            className="btn btn-secondary btn-block" data-dismiss="modal"
                            onClick={(e) => handleClose()}
                            style={{ marginTop: "10px", marginBottom: "10px" }}
                            value={t("page.close")}
                        ></input>
                    </div>
                </div>
                : null}
        </>
    );
}

export default ListDelegateProducts;